import React, { Component } from 'react';
import './Instructions.css';

import Instructions1 from './.image/Instructions1.png';
import Instructions2 from './.image/Instructions2.png';
import Instructions3 from './.image/Instructions3.png';

export class Instructions extends Component {

    constructor(props) {
        super(props);

        this.state = {
        };
    }


    render() {
        return (
            <div className="instructions">
                <div className="instructions-row">
                    <img src={Instructions1} width={500} height={300} alt="Instructions1" />
                </div>
                <div className="instructions-row">
                    <img src={Instructions2} width={500} height={300} alt="Instructions2" />
                    <img src={Instructions3} width={500} height={300} alt="Instructions3" />
                </div>

            </div>
        );
    }
}